import React, { useContext } from 'react';
import {
  CircularProgress,
  Box
} from '@mui/material';
import { AuthContext } from '../context/AuthContext';
import RequireAuth from './RequireAuth';

const AuthGuard = ({ children }) => {
  // const { isSignedIn, isLoaded } = useAuth();
  // const { user } = useUser();
  
  // Using AuthContext instead of Clerk
  const { user, loading } = useContext(AuthContext);

  // Show loading spinner while auth is loading
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          backgroundColor: '#f9fafc',
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  // Show RequireAuth page if not authenticated
  if (!user) {
    return <RequireAuth />;
  }

  // If not authenticated, the useEffect will redirect to auth page
  // Show loading while redirecting
  if (!user) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          backgroundColor: '#f9fafc',
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  // User is authenticated, render the children
  return <>{children}</>;
};

export default AuthGuard;
